import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../provider/authContextType';

const fetchFamilyComposition = async (
  payload: any,
  contractNumber: string,
  code: string,
  origin: string | null
) => {
  const response = await axios.get(`${origin}/contract/familyComposition`, {
    params: {
      contractNumber: contractNumber,
      code: code,
      identityDocument: payload.identityDocument,
      identityDocumentTypeId: payload.identityDocumentTypeId,
    },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer `,
    },
  });
  return response.data;
};

export const useFetchFamilyComposition = (
  payload: any,
  contractNumber: string,
  code: string,
  page: string,
  size: string
) => {
  const { origin } = useAuth();
  return useQuery({
    queryKey: ['familyComposition', contractNumber, code, page, size],
    queryFn: () => {
      return fetchFamilyComposition(payload, contractNumber, code, origin);
    },
  });
};
